// extracted by mini-css-extract-plugin
export var quantityInput = "_jr-0";